var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,style:(_vm.slickStyle)},[_vm._l((_vm.copyList),function(item){return [_vm._t("slickItem",null,{"item":item,"itemStyle":_vm.itemStyle})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }